import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { InfoModalComponent } from './info-modal.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendModalModule } from '@tablesready/frontend-modal';

@NgModule({
  declarations: [InfoModalComponent],
  imports: [
    FrontendIconsModule,
    CommonModule,
    NgbModalModule,
    FrontendModalModule,
  ],
  exports: [InfoModalComponent],
})
export class InfoModalModule {}
